<template>
	<div class="contenido-2-columnas-A-full">
		<div class="contenedor-contenido-2-columnas">

			<h1>Sending Us Your Files</h1>
			<div class="contenido">
				<div class="modulo">
					<p>We prefer to work with files in pdf format.</p>
					<p>You may transmit us your files in the following ways:</p>
					<ul style='color: #6B6B6B'>
						<li style="line-height: 100%"><a v-b-modal.modalResidential class="upload">Send us your files to our Dropbox account</a></li>
						<li style="line-height: 100%">If under 25M send in a regular email to projects[at]easytitle24.com</li>
						<li style="line-height: 100%">Use a service like Google Drive or Dropbox to share your files with projects[at]easytitle24.com</li>
						<li style="line-height: 100%">Use the free service <a href='https://wetransfer.com' target='_new'>wetransfer.com</a> to upload your files and notify us at projects[at]easytitle24.com</li>
					</ul>
					<p>Call us at 415-259-4068 if you need further assistance</p>
				</div>
			</div>
			<p></p>
			<h1>How much will I save using your services?</h1>
			<div class="contenido">
				<div class="modulo ">
					<p class="caja-texto1">
						The main cost savings—as compared to most/all other Title 24
						services — will be in the construction phase for materials and/or
						labor. These savings could be nominal, or they could be very
						significant.
					</p>
					<p class="caja-texto1">
						There may be additional savings that result from timely plan
						checking due to the quality of our work. At the same time, we check
						periodically to make sure our fees are very competitive for the
						level of services we provide.
					</p>
					<p class="caja-texto1">
						Please use our <router-link to='/compliance-wizard'>Cost-Estimator
						“wizard”</router-link> to determine the scope and type of project
						you have, and our basic fee options. 
						<a v-b-modal.modalResidential class="upload">Share your plans with us</a>
						if you would like specific advice and a firm quote.
					</p>
				</div>
				<img class="image-price" src="~Img/prices.jpg" >
			</div>
		</div>
		<b-modal id="modalResidential"  size="sm" centered hide-footer title="Upload your files ">
			<upload-pop-up uploadType='all' />
		</b-modal>
	</div>
</template>
<script>
import uploadPopUp from '@/commonSite/uploadFiles'
export default {
	name: 'content2-columns',
	components: {
		uploadPopUp
	}
}
</script>



// WEBPACK FOOTER //
// src/components/full/content2columnsFull.vue